<template>
  <div style="height: 100%">
    <header-box />
    <div class="registered-body">
      <div>
        <div class="registered-title">
          <strong>重置密码</strong>
          <p>已有账号？<span @click="$router.push('/login')">登录</span></p>
        </div>
        <div class="registered-content-body">
          <email-reset-pass v-if="resetType == 'email'" />
          <account-info v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBox from "../beforeLayout/header.vue";
import AccountInfo from "./modules/AccountInfo.vue";
import emailResetPass from "./emailResetPass.vue";
export default {
  components: {
    headerBox,
    AccountInfo,
    emailResetPass,
  },
  data() {
    return {
      resetType: "mobile", //'email'
    };
  },
};
</script>

<style lang="less" scoped>
.registered-body {
  background: #f6f8fb;
  height: calc(100% - 64px);
  overflow-y: auto;
  > div {
    width: 1200px;
    margin: 0 auto;
    padding-top: 50px;

    .registered-title {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;

      > strong {
        font-size: 34px;
        line-height: 34px;
      }

      > p {
        font-size: 14px;
        line-height: 14px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -7px;
        color: #8c8c8c;

        > span {
          color: #1abc9c;
          cursor: pointer;
          z-index: 2;
        }
      }
    }

    .registered-content-body {
      height: 680px;
      background: #ffffff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      margin-top: 40px;
    }
  }
}
</style>
